export default import.meta.ROLLDOWN_FILE_URL_TmbHgQa4qD5g3LfZTFHWKA